var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { PublisherDashboardService } from '../../dashboard/publisher-dashboard.service';
import { Principal } from '../../../shared/auth/principal.service';
import { MatTableDataSource } from '@angular/material/table';
import { PodcastClip, RSSFeed } from '../../../shared/domain/rss.model';
import { MatDialog } from '@angular/material/dialog';
import { PodcastClipEditDialogComponent } from './podcast-clip-edit-dialog.component';
import { GlobalSpinnerService } from '../../../shared/components/loader-service/global-spinner.service';
import { environment } from '../../../../environments/environment';
import { SnackBarService } from '../../../shared/services/snackbar.service';
import { DeleteDialogComponent } from '../../../shared/components/dialogs/delete-dialog.component';
var PromocastComponent = /** @class */ (function () {
    function PromocastComponent(dashboardService, principal, matDialog, spinnerService, sbs) {
        this.dashboardService = dashboardService;
        this.principal = principal;
        this.matDialog = matDialog;
        this.spinnerService = spinnerService;
        this.sbs = sbs;
        this.podcastClipsDataSource = new MatTableDataSource();
        this.rssFeedsDataSource = new MatTableDataSource();
        this.rssFeedColumns = ['name', 'url', 'status', 'enabled', 'actions'];
        this.podcastClipColumns = ['seriesName', 'episodeName', 'itemDuration', 'audio', 'clickThroughUrl', 'channelLanguage', 'channelImage', 'status', 'enabled', 'actions'];
    }
    PromocastComponent.prototype.ngOnInit = function () {
        this.refreshData();
    };
    PromocastComponent.prototype.getJsonData = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(url)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    PromocastComponent.prototype.enroll = function () {
        var _this = this;
        this.spinnerService.showLoader();
        this.dashboardService.enrollInPromocast().subscribe(function (data) {
            _this.principal.publisher = data;
            _this.spinnerService.hideLoader();
        });
    };
    PromocastComponent.prototype.refreshData = function () {
        var _this = this;
        this.rssFeedLoading = true;
        this.dashboardService.getRssFeeds().subscribe(function (data) {
            _this.rssFeedsDataSource.data = data;
            _this.rssFeedLoading = false;
        });
        this.podcastClipsLoading = true;
        this.getJsonData(environment.publisherApiUrl + "/country-codes").then(function (data) {
            _this.languageCodes = new Map();
            for (var property in data) {
                _this.languageCodes.set(property, data[property]);
            }
            _this.dashboardService.getPodcastClips().subscribe(function (clips) {
                _this.podcastClipsDataSource.data = clips;
                _this.podcastClipsLoading = false;
            });
        });
    };
    PromocastComponent.prototype.addPodcastClip = function () {
        var _this = this;
        var rss = new PodcastClip();
        this.matDialog.open(PodcastClipEditDialogComponent, {
            data: {
                record: Object.assign({}, rss),
                isUpdate: false,
                languageCodes: this.languageCodes,
                type: 'AUDIO_FILE'
            },
            width: '400px'
        }).afterClosed().subscribe(function (next) {
            if (next) {
                _this.podcastClipsDataSource.data = next;
            }
        });
    };
    PromocastComponent.prototype.updatePodcastClip = function (rssFeed) {
        var _this = this;
        this.matDialog.open(PodcastClipEditDialogComponent, {
            data: {
                record: Object.assign({}, rssFeed),
                isUpdate: true,
                languageCodes: this.languageCodes,
                type: 'AUDIO_FILE'
            },
            width: '600px'
        }).afterClosed().subscribe(function (next) {
            if (next) {
                _this.podcastClipsDataSource.data = next;
            }
        });
    };
    PromocastComponent.prototype.addRssFeedUrl = function () {
        var _this = this;
        var rss = new RSSFeed();
        this.matDialog.open(PodcastClipEditDialogComponent, {
            data: {
                rss_record: Object.assign({}, rss),
                isUpdate: false,
                languageCodes: this.languageCodes,
                type: 'RSS_FEED'
            },
            width: '400px'
        }).afterClosed().subscribe(function (next) {
            if (next) {
                _this.rssFeedsDataSource.data = next;
            }
        });
    };
    PromocastComponent.prototype.updateRssFeed = function (rssFeed) {
        var _this = this;
        this.matDialog.open(PodcastClipEditDialogComponent, {
            data: {
                rss_record: Object.assign({}, rssFeed),
                isUpdate: true,
                type: 'RSS_FEED'
            },
            width: '400px'
        }).afterClosed().subscribe(function (next) {
            if (next) {
                _this.rssFeedsDataSource.data = next;
            }
        });
    };
    PromocastComponent.prototype.deleteRssFeed = function (element) {
        var _this = this;
        this.matDialog.open(DeleteDialogComponent, {
            data: {
                title: element.name,
                subtitle: 'Are you sure you want to delete this record?',
                confirmButtonText: 'Yes, delete!'
            }
        }).afterClosed().subscribe(function (next) {
            if (next) {
                _this.rssFeedLoading = true;
                _this.dashboardService.deleteRssFeed(element).subscribe(function (data) {
                    _this.rssFeedsDataSource.data = data;
                    _this.rssFeedLoading = false;
                });
            }
        });
    };
    PromocastComponent.prototype.deletePodcastClip = function (element) {
        var _this = this;
        this.matDialog.open(DeleteDialogComponent, {
            data: {
                title: element.name,
                subtitle: 'Are you sure you want to delete this record?',
                confirmButtonText: 'Yes, delete!'
            }
        }).afterClosed().subscribe(function (next) {
            if (next) {
                _this.podcastClipsLoading = true;
                _this.dashboardService.deletePodcastClip(element).subscribe(function (data) {
                    _this.podcastClipsDataSource.data = data;
                    _this.podcastClipsLoading = false;
                });
            }
        });
    };
    PromocastComponent.prototype.update = function (element, event) {
        var _this = this;
        element.enabled = event.target.checked;
        this.dashboardService.updatePodcastClip(element, null, null).subscribe(function (next) {
            _this.spinnerService.hideLoader();
            if (next) {
                _this.podcastClipsDataSource.data = next;
            }
        }, function (error) {
            _this.sbs.error(error.error.error.messages[0]);
            _this.spinnerService.hideLoader();
        });
    };
    PromocastComponent.prototype.updateFeedEnabled = function (element, event) {
        var _this = this;
        element.enabled = event.target.checked;
        this.dashboardService.updateFeed(element).subscribe(function (next) {
            _this.spinnerService.hideLoader();
            if (next) {
                _this.rssFeedsDataSource.data = next;
            }
        }, function (error) {
            _this.sbs.error(error.error.error.messages[0]);
            _this.spinnerService.hideLoader();
        });
    };
    return PromocastComponent;
}());
export { PromocastComponent };
